<h2 class="page-title col-12">Personnalisation des usages</h2>

<form [formGroup]="form">
  <fieldset>
    <legend>Informations générales</legend>
    <div class="mb-3 d-flex flex-wrap align-items-center gap-2">
      <label for="nbOccupant" class="question">Quel est le nombre d'occupants de votre logement ?</label>
      <input id="nbOccupant" class="form-control" type="number" min="1" formControlName="nbOccupants">
    </div>
    <div class="mb-3">
      <span class="question">Habituellement, vous chauffez votre salon à :</span><br>

      <div class="radio-line-button">
        <input type="radio" [value]="HabitudeChauffageEnum.HABITUDE_CHAUFFAGE_18" id="r-temp-moins-18"
          formControlName="habitudeChauffage">
        <label for="r-temp-moins-18">Moins de 18°C</label>

        <input type="radio" [value]="HabitudeChauffageEnum.HABITUDE_CHAUFFAGE_19" id="r-temp-19"
          formControlName="habitudeChauffage">
        <label for="r-temp-19">19°C</label>

        <input type="radio" [value]="HabitudeChauffageEnum.HABITUDE_CHAUFFAGE_20" id="r-temp-20"
          formControlName="habitudeChauffage">
        <label for="r-temp-20">20°C</label>

        <input type="radio" [value]="HabitudeChauffageEnum.HABITUDE_CHAUFFAGE_21" id="r-temp-21"
          formControlName="habitudeChauffage">
        <label for="r-temp-21">21°C</label>

        <input type="radio" [value]="HabitudeChauffageEnum.HABITUDE_CHAUFFAGE_22" id="r-temp-22"
          formControlName="habitudeChauffage">
        <label for="r-temp-22">22°C</label>

        <input type="radio" [value]="HabitudeChauffageEnum.HABITUDE_CHAUFFAGE_23" id="r-temp-plus-23"
          formControlName="habitudeChauffage">
        <label for="r-temp-plus-23">Plus de 23°C</label>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <legend>Personnalisation avancée</legend>

    <div id="nav">
      <div class="item" [class.active]="activeTab === TabsEnum.CUISSON" (click)="switchTab(TabsEnum.CUISSON)">
        <span class="icon icon-clea-micro-onde"></span>
        <span class="title">Cuisson</span>
      </div>
      <div class="item" [class.active]="activeTab === TabsEnum.EQUIPEMENTS_DOMESTIQUE"
        (click)="switchTab(TabsEnum.EQUIPEMENTS_DOMESTIQUE)">
        <span class="icon icon-clea-lave-linge"></span>
        <span class="title">Équipements domestique</span>
      </div>
      <div class="item" [class.active]="activeTab === TabsEnum.ECLAIRAGE" (click)="switchTab(TabsEnum.ECLAIRAGE)">
        <span class="icon icon-clea-ampoule"></span>
        <span class="title">Éclairage</span>
      </div>
      <div class="item" [class.active]="activeTab === TabsEnum.SALLE_D_EAU" (click)="switchTab(TabsEnum.SALLE_D_EAU)">
        <span class="icon icon-clea-baignoire"></span>
        <span class="title">Salle d'eau</span>
      </div>
      @if (hasEnergiesToTune()) {
        <div class="item" [class.active]="activeTab === TabsEnum.ENERGIE" (click)="switchTab(TabsEnum.ENERGIE)"
          >
          <span class="icon icon-clea-energie"></span>
          <span class="title">Énergie</span>
        </div>
      }
    </div>

    <div id="tabs">
      @if (isActiveTab(TabsEnum.CUISSON)) {
        <div>
          <span class="question">Vous disposez de :</span>
          <div class="row">
            <div class="col-md-6">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" formControlName="cuissonPlaqueElecFixe"
                  id="cuissonPlaqueElecFixe">
                <label class="form-check-label" for="cuissonPlaqueElecFixe">Plaque de cuisson électrique fixe</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" formControlName="cuissonPlaqueElecPort"
                  id="cuissonPlaqueElecPort">
                <label class="form-check-label" for="cuissonPlaqueElecPort">Plaque de cuisson électrique posable</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" formControlName="cuissonPlaqueGazFixe"
                  id="cuissonPlaqueGazFixe">
                <label class="form-check-label" for="cuissonPlaqueGazFixe">Plaque de cuisson gaz fixe</label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" formControlName="cuissonFourElec"
                  id="cuissonFourElec">
                <label class="form-check-label" for="cuissonFourElec">Four traditionnel électrique</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" formControlName="cuissonFourGaz"
                  id="cuissonFourGaz">
                <label class="form-check-label" for="cuissonFourGaz">Four traditionnel gaz</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" formControlName="cuissonFourMicroondes"
                  id="cuissonFourMicroondes">
                <label class="form-check-label" for="cuissonFourMicroondes">Four à micro-ondes</label>
              </div>
            </div>
          </div>
          <span class="question">Concernant vos habitudes de cuisson, vous cuisinez chez vous :</span>
          <div class="radio-line-button text-center">
            <input type="radio" [value]="HabitudeCuissonEnum.HABITUDE_CUISSON_CUISINEZ_SOUVENT"
              id="HABITUDE_CUISSON_CUISINEZ_SOUVENT" name="habitudesCuisson" formControlName="habitudesCuisson">
            <label for="HABITUDE_CUISSON_CUISINEZ_SOUVENT">Souvent<br/>(6 à 7j/semaine)</label>
            <input type="radio" [value]="HabitudeCuissonEnum.HABITUDE_CUISSON_CUISINEZ_REGULIEREMENT"
              id="HABITUDE_CUISSON_CUISINEZ_REGULIEREMENT" name="habitudesCuisson"
              formControlName="habitudesCuisson">
            <label for="HABITUDE_CUISSON_CUISINEZ_REGULIEREMENT">Régulièrement<br/>(4 à 5j/semaine)</label>
            <input type="radio" [value]="HabitudeCuissonEnum.HABITUDE_CUISSON_CUISINEZ_RAREMENT"
              id="HABITUDE_CUISSON_CUISINEZ_RAREMENT" name="habitudesCuisson" formControlName="habitudesCuisson">
            <label for="HABITUDE_CUISSON_CUISINEZ_RAREMENT">Rarement<br/>(1 à 3j/semaine)</label>
          </div>
          <span class="question">Concernant vos habitudes d'utilisation des appareils de cuisson, vous utilisez :</span>
          <div class="radio-line-button text-center">
            <input type="radio" [value]="UtilisationCuissonEnum.UTILISATION_CUISSON_PLAQUES"
              id="UTILISATION_CUISSON_PLAQUES" name="utilisationCuisson" formControlName="utilisationCuisson">
            <label for="UTILISATION_CUISSON_PLAQUES">Majoritairement vos plaques de cuisson</label>
            <input type="radio" [value]="UtilisationCuissonEnum.UTILISATION_CUISSON_FOUR" id="UTILISATION_CUISSON_FOUR"
              name="utilisationCuisson" formControlName="utilisationCuisson">
            <label for="UTILISATION_CUISSON_FOUR">Majoritairement votre four</label>
            <input type="radio" [value]="UtilisationCuissonEnum.UTILISATION_CUISSON_FOUR_ET_PLAQUES"
              id="UTILISATION_CUISSON_FOUR_ET_PLAQUES" name="utilisationCuisson"
              formControlName="utilisationCuisson">
            <label for="UTILISATION_CUISSON_FOUR_ET_PLAQUES">Aussi bien vos plaques que votre four</label>
          </div>
        </div>
      }
      @if (isActiveTab(TabsEnum.EQUIPEMENTS_DOMESTIQUE)) {
        <div class="equipements-domestiques">
          <span class="question">Vous disposez de :</span>
          <div class="row">
            <div class="col-sm-6"><label for="combineNb">Combiné Réfrigérateur / Congélateur</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="combineNb" type="number" min="0" formControlName="combineNb">
            </div>
            <div class="col-sm-4">
              @if (form.controls.combineNb.value > 0) {
                <app-note-energie [value]="form.controls.classeEnerCombi.value"
                  (changed)="form.controls.classeEnerCombi.setValue($event)"
                title="Classe énergétique moyenne"></app-note-energie>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6"><label for="refrigerateurNb">Réfrigérateur</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="refrigerateurNb" type="number" min="0" formControlName="refrigerateurNb">
            </div>
            <div class="col-sm-4">
              @if (form.controls.refrigerateurNb.value > 0) {
                <app-note-energie
                  [value]="form.controls.classeEnerRefrigerateur.value"
                  (changed)="form.controls.classeEnerRefrigerateur.setValue($event)"
                title="Classe énergétique moyenne"></app-note-energie>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6"><label for="congelateurNb">Congélateur</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="congelateurNb" type="number" min="0" formControlName="congelateurNb">
            </div>
            <div class="col-sm-4">
              @if (form.controls.congelateurNb.value > 0) {
                <app-note-energie
                  [value]="form.controls.classeEnerCongelateur.value"
                  (changed)="form.controls.classeEnerCongelateur.setValue($event)"
                title="Classe énergétique moyenne"></app-note-energie>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6"><label for="laveLingeNb">Lave-linge</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="laveLingeNb" type="number" min="0" formControlName="laveLingeNb">
            </div>
            <div class="col-sm-4">
              @if (form.controls.laveLingeNb.value > 0) {
                <app-note-energie
                  [value]="form.controls.classeEnerLaveLinge.value"
                  (changed)="form.controls.classeEnerLaveLinge.setValue($event)"
                title="Classe énergétique moyenne"></app-note-energie>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6"><label for="secheLingeNb">Sèche-linge</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="secheLingeNb" type="number" min="0" formControlName="secheLingeNb">
            </div>
            <div class="col-sm-4">
              @if (form.controls.secheLingeNb.value > 0) {
                <app-note-energie
                  [value]="form.controls.classeEnerSecheLinge.value"
                  (changed)="form.controls.classeEnerSecheLinge.setValue($event)"
                title="Classe énergétique moyenne"></app-note-energie>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6"><label for="laveVaisselleNb">Lave-vaisselle</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="laveVaisselleNb" type="number" min="0" formControlName="laveVaisselleNb">
            </div>
            <div class="col-sm-4">
              @if (form.controls.laveVaisselleNb.value > 0) {
                <app-note-energie
                  [value]="form.controls.classeEnerLaveVaisselle.value"
                  (changed)="form.controls.classeEnerLaveVaisselle.setValue($event)"
                title="Classe énergétique moyenne"></app-note-energie>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6"><label for="tvLcdNb">Téléviseur LCD / LED</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="tvLcdNb" type="number" min="0" formControlName="tvLcdNb">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6"><label for="tvPlasmaNb">Téléviseur Plasma</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="tvPlasmaNb" type="number" min="0" formControlName="tvPlasmaNb">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6"><label for="ordinateurNb">Ordinateur fixe</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="ordinateurNb" type="number" min="0" formControlName="ordinateurNb">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6"><label for="imprimanteNb">Imprimantes</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="imprimanteNb" type="number" min="0" formControlName="imprimanteNb">
            </div>
          </div>
        </div>
      }
      @if (isActiveTab(TabsEnum.ECLAIRAGE)) {
        <div class="eclairage">
          <span class="question">Vous disposez de :</span>
          <div class="row">
            <div class="col-sm-6"><label for="lampadairesNb">Lampadaire</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="lampadairesNb" type="number" min="0" formControlName="lampadairesNb">
            </div>
            <div class="col-sm-4">
              @if (form.controls.lampadairesNb.value > 0) {
                <div class="radio-line-button">
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_FLUOCOMPACTE" id="lampadaire-AMPOULE_FLUOCOMPACTE"
                    formControlName="lampadairesAmpoule">
                  <label for="lampadaire-AMPOULE_FLUOCOMPACTE" [title]="AmpouleEnum.AMPOULE_FLUOCOMPACTE | ampouleType"><span
                  class="icon icon-clea-ampoule-fluocompacte"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_FLUORESCENT" id="lampadaire-AMPOULE_FLUORESCENT"
                    formControlName="lampadairesAmpoule">
                  <label for="lampadaire-AMPOULE_FLUORESCENT" [title]="AmpouleEnum.AMPOULE_FLUORESCENT | ampouleType"><span
                  class="icon icon-clea-ampoule-fluorescente"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_HALOGENE" id="lampadaire-AMPOULE_HALOGENE"
                    formControlName="lampadairesAmpoule">
                  <label for="lampadaire-AMPOULE_HALOGENE" [title]="AmpouleEnum.AMPOULE_HALOGENE | ampouleType"><span class="icon icon-clea-ampoule-hallogene"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_LED" id="lampadaire-AMPOULE_LED"
                    formControlName="lampadairesAmpoule">
                  <label for="lampadaire-AMPOULE_LED" [title]="AmpouleEnum.AMPOULE_LED | ampouleType"><span class="icon icon-clea-ampoule-led"></span></label>
                  <span class="selected">{{ form.controls.lampadairesAmpoule.value | ampouleType }}</span>
                </div>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6"><label for="lampesNb">Lampes à poser</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="lampesNb" type="number" min="0" formControlName="lampesNb">
            </div>
            <div class="col-sm-4">
              @if (form.controls.lampesNb.value > 0) {
                <div class="radio-line-button">
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_FLUOCOMPACTE" id="lampes-AMPOULE_FLUOCOMPACTE"
                    formControlName="lampesAmpoule">
                  <label for="lampes-AMPOULE_FLUOCOMPACTE" [title]="AmpouleEnum.AMPOULE_FLUOCOMPACTE | ampouleType"><span class="icon icon-clea-ampoule-fluocompacte"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_FLUORESCENT" id="lampes-AMPOULE_FLUORESCENT"
                    formControlName="lampesAmpoule">
                  <label for="lampes-AMPOULE_FLUORESCENT" [title]="AmpouleEnum.AMPOULE_FLUORESCENT | ampouleType"><span class="icon icon-clea-ampoule-fluorescente"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_HALOGENE" id="lampes-AMPOULE_HALOGENE"
                    formControlName="lampesAmpoule">
                  <label for="lampes-AMPOULE_HALOGENE" [title]="AmpouleEnum.AMPOULE_HALOGENE | ampouleType"><span class="icon icon-clea-ampoule-hallogene"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_LED" id="lampes-AMPOULE_LED"
                    formControlName="lampesAmpoule">
                  <label for="lampes-AMPOULE_LED" [title]="AmpouleEnum.AMPOULE_LED | ampouleType"><span class="icon icon-clea-ampoule-led"></span></label>
                  <span class="selected">{{ form.controls.lampesAmpoule.value | ampouleType }}</span>
                </div>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6"><label for="plafonniersNb">Suspension / Plafonnier</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="plafonniersNb" type="number" min="0" formControlName="plafonniersNb">
            </div>
            <div class="col-sm-4">
              @if (form.controls.plafonniersNb.value > 0) {
                <div class="radio-line-button">
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_FLUOCOMPACTE" id="plafonniers-AMPOULE_FLUOCOMPACTE"
                    formControlName="plafonniersAmpoule">
                  <label for="plafonniers-AMPOULE_FLUOCOMPACTE" [title]="AmpouleEnum.AMPOULE_FLUOCOMPACTE | ampouleType"><span
                  class="icon icon-clea-ampoule-fluocompacte"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_FLUORESCENT" id="plafonniers-AMPOULE_FLUORESCENT"
                    formControlName="plafonniersAmpoule">
                  <label for="plafonniers-AMPOULE_FLUORESCENT" [title]="AmpouleEnum.AMPOULE_FLUORESCENT | ampouleType"><span
                  class="icon icon-clea-ampoule-fluorescente"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_HALOGENE" id="plafonniers-AMPOULE_HALOGENE"
                    formControlName="plafonniersAmpoule">
                  <label for="plafonniers-AMPOULE_HALOGENE" [title]="AmpouleEnum.AMPOULE_HALOGENE | ampouleType"><span class="icon icon-clea-ampoule-hallogene"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_LED" id="plafonniers-AMPOULE_LED"
                    formControlName="plafonniersAmpoule">
                  <label for="plafonniers-AMPOULE_LED" [title]="AmpouleEnum.AMPOULE_LED | ampouleType"><span class="icon icon-clea-ampoule-led"></span></label>
                  <span class="selected">{{ form.controls.plafonniersAmpoule.value | ampouleType }}</span>
                </div>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6"><label for="appliquesNb">Appliques</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="appliquesNb" type="number" min="0" formControlName="appliquesNb">
            </div>
            <div class="col-sm-4">
              @if (form.controls.appliquesNb.value > 0) {
                <div class="radio-line-button">
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_FLUOCOMPACTE" id="appliques-AMPOULE_FLUOCOMPACTE"
                    formControlName="appliquesAmpoule">
                  <label for="appliques-AMPOULE_FLUOCOMPACTE" [title]="AmpouleEnum.AMPOULE_FLUOCOMPACTE | ampouleType"><span
                  class="icon icon-clea-ampoule-fluocompacte"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_FLUORESCENT" id="appliques-AMPOULE_FLUORESCENT"
                    formControlName="appliquesAmpoule">
                  <label for="appliques-AMPOULE_FLUORESCENT" [title]="AmpouleEnum.AMPOULE_FLUORESCENT | ampouleType"><span
                  class="icon icon-clea-ampoule-fluorescente"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_HALOGENE" id="appliques-AMPOULE_HALOGENE"
                    formControlName="appliquesAmpoule">
                  <label for="appliques-AMPOULE_HALOGENE" [title]="AmpouleEnum.AMPOULE_HALOGENE | ampouleType"><span class="icon icon-clea-ampoule-hallogene"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_LED" id="appliques-AMPOULE_LED"
                    formControlName="appliquesAmpoule">
                  <label for="appliques-AMPOULE_LED" [title]="AmpouleEnum.AMPOULE_LED | ampouleType"><span class="icon icon-clea-ampoule-led"></span></label>
                  <span class="selected">{{ form.controls.appliquesAmpoule.value | ampouleType }}</span>
                </div>
              }
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6"><label for="spotsNb">Spots</label></div>
            <div class="col-sm-2">
              <input class="form-control" id="spotsNb" type="number" min="0" formControlName="spotsNb">
            </div>
            <div class="col-sm-4">
              @if (form.controls.spotsNb.value > 0) {
                <div class="radio-line-button">
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_FLUOCOMPACTE" id="spots-AMPOULE_FLUOCOMPACTE"
                    formControlName="spotsAmpoule">
                  <label for="spots-AMPOULE_FLUOCOMPACTE" [title]="AmpouleEnum.AMPOULE_FLUOCOMPACTE | ampouleType"><span class="icon icon-clea-ampoule-fluocompacte"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_FLUORESCENT" id="spots-AMPOULE_FLUORESCENT"
                    formControlName="spotsAmpoule">
                  <label for="spots-AMPOULE_FLUORESCENT" [title]="AmpouleEnum.AMPOULE_FLUORESCENT | ampouleType"><span class="icon icon-clea-ampoule-fluorescente"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_HALOGENE" id="spots-AMPOULE_HALOGENE"
                    formControlName="spotsAmpoule">
                  <label for="spots-AMPOULE_HALOGENE" [title]="AmpouleEnum.AMPOULE_HALOGENE | ampouleType"><span class="icon icon-clea-ampoule-hallogene"></span></label>
                  <input type="radio" [value]="AmpouleEnum.AMPOULE_LED" id="spots-AMPOULE_LED"
                    formControlName="spotsAmpoule">
                  <label for="spots-AMPOULE_LED" [title]="AmpouleEnum.AMPOULE_LED | ampouleType"><span class="icon icon-clea-ampoule-led"></span></label>
                  <span class="selected">{{ form.controls.spotsAmpoule.value | ampouleType }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (isActiveTab(TabsEnum.SALLE_D_EAU)) {
        <div>
          <span class="question">Vous prenez plutôt :</span>
          <div class="radio-line-button">
            <input type="radio" [value]="HabitudeECSEnum.HABITUDE_ECS_DOUCHES" id="habitude-ecs-HABITUDE_ECS_DOUCHES"
              formControlName="habitudesEcs">
            <label for="habitude-ecs-HABITUDE_ECS_DOUCHES">Des douches</label>
            <input type="radio" [value]="HabitudeECSEnum.HABITUDE_ECS_BAINS_ET_DOUCHES"
              id="habitude-ecs-HABITUDE_ECS_BAINS_ET_DOUCHES"
              formControlName="habitudesEcs">
            <label for="habitude-ecs-HABITUDE_ECS_BAINS_ET_DOUCHES">Des bains et des douches</label>
            <input type="radio" [value]="HabitudeECSEnum.HABITUDE_ECS_BAINS" id="habitude-ecs-HABITUDE_ECS_BAINS"
              formControlName="habitudesEcs">
            <label for="habitude-ecs-HABITUDE_ECS_BAINS">Des bains</label>
          </div>
        </div>
      }
      @if (isActiveTab(TabsEnum.ENERGIE) && hasEnergiesToTune()) {
        <div class="energies">
          <span class="question">Coefficients de conversion :</span>
          <div class="coefs">
            @if (hasGaz()) {
              <label for="coefConversionGaz">
                <span class="icon icon-clea-gaz"></span>
                <span class="title">Gaz</span>
                <input id="coefConversionGaz" class="form-control" type="number" min="1"
                  formControlName="coefConversionGaz">
              </label>
            }
            @if (hasFioul()) {
              <label for="coefConversionFioul">
                <span class="icon icon-clea-eau"></span>
                <span class="title">Fioul</span>
                <input id="coefConversionFioul" class="form-control" type="number" min="1"
                  formControlName="coefConversionFioul">
              </label>
            }
          </div>
        </div>
      }
    </div>

  </fieldset>
  <div id="submit">
    <div class="row">
      <div class="col-sm-6 offset-3">
        <button class="btn btn-orange btn-lg w-100" (click)="submit()">Enregistrer</button>
      </div>
    </div>
  </div>
</form>
